var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "download",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.7779541,9.01426914 L11.0064785,5.98095703 C11.2993717,5.68806381 11.7742455,5.68806381 12.0671387,5.98095703 C12.3600319,6.27385025 12.3600319,6.74872398 12.0671387,7.0416172 L7.06795044,11.8999023 L1.97705955,7.0416172 C1.68416634,6.74872398 1.68416634,6.27385025 1.97705955,5.98095703 C2.26995277,5.68806381 2.74482651,5.68806381 3.03771973,5.98095703 L6.2779541,8.95600167 L6.2779541,0.75769043 C6.2779541,0.343476867 6.61374054,0.00769042969 7.0279541,0.00769042969 C7.44216766,0.00769042969 7.7779541,0.343476867 7.7779541,0.75769043 L7.7779541,9.01426914 Z M1.7611084,12.480835 L12.2611084,12.480835 C12.675322,12.480835 13.0111084,12.8166214 13.0111084,13.230835 C13.0111084,13.6450485 12.675322,13.980835 12.2611084,13.980835 L1.7611084,13.980835 C1.34689484,13.980835 1.0111084,13.6450485 1.0111084,13.230835 C1.0111084,12.8166214 1.34689484,12.480835 1.7611084,12.480835 Z",
    id: "icon-download",
    fill: "#6D7A90",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.7920fb70ba30eaee42fe4f16c96aa4c8.svg";
export { ForwardRef as ReactComponent };